import { useMutation, useQuery, useQueryClient } from 'react-query';
import { getUserId } from '../../../DefaultService';
import {
  getVideoProcessingQueueAsync,
  getVideoProcessingQueueDevicesAsync,
  retryVideosBulkAsync,
  retryVideoProcessingAsync,
} from '../../index';
import { IVideoProcessingQueueFilterProps } from '../../types';

const USER_ID = getUserId();

// Fila "viva": reflete o estado do Postgres, atualizado pelo sports-api a cada etapa. 3s pra ficar
// bem próximo do dashboard interno dele.
const REFETCH_INTERVAL_MS = 3000;

export const useGetVideoProcessingQueueQuery = (filter: IVideoProcessingQueueFilterProps) =>
  useQuery(['sportVideoProcessingQueue', USER_ID, filter], {
    keepPreviousData: true,
    refetchInterval: REFETCH_INTERVAL_MS,
    queryFn: () => getVideoProcessingQueueAsync(filter),
  });

export const useGetVideoProcessingQueueDevicesQuery = () =>
  useQuery(['sportVideoProcessingQueueDevices', USER_ID], {
    queryFn: getVideoProcessingQueueDevicesAsync,
  });

export const useRetryVideoProcessingMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(retryVideoProcessingAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries(['sportVideoProcessingQueue', USER_ID]);
    },
  });
};

export const useRetryVideosBulkMutation = () => useMutation(retryVideosBulkAsync);
